module.exports = __webpack_public_path__ + "static/img/news34.d46630f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news34.png
// module id = P8TK
// module chunks = 0